// potentially a view in itself, this module allows a user to select
// any of the available views to display.

import { createEl, appendChildren, createAniButton } from "./utils";
import popup_contact from "../Views/popups/contact.cshtml";
import popup_outro from "../Views/popups/outro.cshtml";
import popup_flightinstruct from "../Views/popups/instructions.cshtml";
import popup_menu from "../Views/popups/menu.cshtml";
import popup_settings from "../Views/popups/settings.cshtml";
import popup_summary from "../Views/popups/summary.cshtml";
import popup_pi from "../Views/popups/pi.cshtml";
import popup_patientcard from "../Views/popups/patientcard.cshtml";

import { updateArray } from "../assets/views/00_common/userActions";

import PathUpdate from "./PathUpdate";

import Lottie from "lottie-web";

export default class Popup {
    constructor(state) {
        this.state = state;
        this.views = [];

        const _this = this;
        const _hasPopUp = false;

        this._path = PathUpdate.getInstance();

        this.views.popupContact = createEl("div", {
            className: "popup-elm contact hidden",
            innerHTML: popup_contact,
        });
        this.views.popupoutro = createEl("div", {
            className: "popup-elm outro hidden",
            innerHTML: popup_outro,
        });
        this.views.popupFlightInstructions = createEl("div", {
            className: "popup-elm instruct popup_scale hidden",
            innerHTML: popup_flightinstruct,
        });
        this.views.popupMenu = createEl("div", {
            className: "popup-elm menu hidden",
            innerHTML: popup_menu,
        });
        this.views.popupSettings = createEl("div", {
            className: "popup-elm menu popup_settings hidden",
            innerHTML: popup_settings,
        });
        this.views.popupSummary = createEl("div", {
            className: "popup-elm instruct popup_scale hidden",
            innerHTML: popup_summary,
        });
        this.views.popupPi = createEl("div", {
            className: "popup-elm instruct pi-popup popup_scale hidden",
            innerHTML: popup_pi,
        });
        this.views.popupPatientcard = createEl("div", {
            className: "popup-elm instruct popup_scale hidden",
            innerHTML: popup_patientcard,
        });

        this.el = createEl("div", { className: "popup" });
        this.el.classList.add("hidden");

        this.resetHistory = this.resetHistory.bind(this);
        this.updateHistory = this.updateHistory.bind(this);

        /// append all the views for popups
        for (let elm in this.views) {
            this.el.appendChild(this.views[elm]);
        }

        /// look for all animated buttons/ close

        let _e,
            _w = [
                this.views.popupMenu,
                this.views.popupoutro,
                this.views.popupFlightInstructions,
                this.views.popupContact,
                this.views.popupSettings,
                this.views.popupSummary,
                this.views.popupPi,
                this.views.popupPatientcard,
            ];

        _w.forEach(function (el) {
            let b = el.querySelectorAll("[data-button]");

            b.forEach(function (btn) {
                _e = btn.getAttribute("data-button-event")
                    ? eval(_this[btn.getAttribute("data-button-event")]).bind(
                          _this
                      )
                    : {};
                if (btn.getAttribute("data-button-href")) {
                    _e = () => {
                        //window.open(btn.getAttribute("data-button-href"), "_blank");
                        console.log("clicked");

                        _this.state.popup = btn.getAttribute("data-popup");
                    };
                }
                let a = createAniButton(btn, _e);
                let ani = Lottie.loadAnimation({
                    container: a,
                    renderer: "svg",
                    loop: false,
                    autoplay: false,
                    path: "/assets/ani/MenuHUDButton.json",
                });
                btn.ani = ani;
            });

            let clse = el.querySelectorAll(".close");
            clse.forEach(function (btn) {
                btn.addEventListener("click", function (e) {
                    console.log("close");
                    _this._path.update("closeView");
                    _this.state.popup = null;
                });
            });

            //let close_view = el.querySelectorAll(".close_view");
            //close_view.forEach(function (btn) {

            //	btn.addEventListener('click', function (e) {
            //		//_this._path.update('closeView');
            //		////_this.state.popup = null;
            //		//_this.popup.views.classList.add('hide_view');
            //		console.log(_this.popup.views);
            //	});
            //});

            let audioToggle = el.querySelectorAll(".sound_div .toggle");
            audioToggle.forEach(function (btn) {
                btn.addEventListener("click", function (e) {
                    _this._path.toggleAudio();
                });
            });

            let ccToggle = el.querySelectorAll(".cc_div .toggle");
            ccToggle.forEach(function (btn) {
                btn.addEventListener("click", function (e) {
                    //console.log("toggle cc");

                    const _m = document.querySelector("#moa-video");
                    window._CC = !window._CC;
                    if (window._CC) {
                        document.body.classList.add("hasCC");
                        //console.log("add cc");
                    } else {
                        document.body.classList.remove("hasCC");
                        //console.log("remove cc");
                    }
                });
            });

            /// look for any elements with data-view attribute

            let o = el.querySelectorAll("[data-view]");
            o.forEach(function (btn) {
                btn.addEventListener("click", function (e) {
                    if (_this.state.view === this.getAttribute("data-view")) {
                        _this.state.view = null;
                    }
                    _this.state.view = this.getAttribute("data-view");
                });
            });
			
			// original
            // let dataTab = el.querySelectorAll("[data-tab]");
            // dataTab.forEach(function (btn) {
            //     btn.addEventListener("click", function (e) {
            //         _this.state.dataTab = this.getAttribute("data-tab");
            //         _this.state.tabView = this.getAttribute("data-view");

            //         let tabVar =
            //             "tab_" +
            //             _this.state.tabView +
            //             "_" +
            //             _this.state.dataTab;
            //         let tabID = document.getElementById(tabVar);

            //         var menu_button_items;

            //         switch (tabVar) {
            //             case "tab_aboutPadcev_1":
            //                 menu_button_items = "Menu_AboutPad_UnmetNeed";
            //                 break;
            //             case "tab_aboutPadcev_2":
            //                 menu_button_items =
            //                     "Menu_AboutPad_TreatmentLandscape";
            //                 break;
            //             case "tab_aboutPadcev_3":
            //                 menu_button_items = "Menu_AboutPad_MOA";
            //                 break;
            //             case "tab_aboutPadcev_4":
            //                 menu_button_items = "Menu_AboutPad_MOAVideo";
            //                 break;

            //             case "tab_populationPost_1":
            //                 menu_button_items =
            //                     "Menu_TrialOverview_StudyDesign";
            //                 break;
            //             case "tab_populationPost_2":
            //                 menu_button_items =
            //                     "Menu_TrialOverview_PatientCharacteristics";
            //                 break;

            //             case "tab_populationCisplatin_1":
            //                 menu_button_items = "Menu_TrialResults_Results";
            //                 break;
            //             case "tab_populationCisplatin_2":
            //                 menu_button_items = "Menu_TrialResults_Safety";
            //                 break;
            //             case "tab_populationCisplatin_3":
            //                 menu_button_items = "Menu_TrialResults_QOL";
            //                 break;

            //             case "tab_dosingAdministration_1":
            //                 menu_button_items = "Menu_DosingAdmin_DosingAdmin";
            //                 break;
            //             case "tab_dosingAdministration_2":
            //                 menu_button_items = "Menu_DosingAdmin_DoseMods";
            //                 break;
            //         }

            //         //trackingVar
            //         //console.log(tabVar);

            //         updateArray(menu_button_items);

            //         localStorage.setItem("active_tab", tabVar);

            //         /////

            //         var sounds = document.getElementsByTagName("audio");
            //         for (i = 0; i < sounds.length; i++) sounds[i].pause();

            //         var playr1 = document.querySelector("#aud_" + tabVar);

            //         if (playr1) {
            //             /// start the audio, check for delay attribute
            //             let d = 0,
            //                 _this = this;
            //             if (playr1.getAttribute("delay")) {
            //                 d = playr1.getAttribute("delay") * 1000;
            //             }

            //             /// settimeout delay (0 if no delay)

            //             setTimeout(function () {
            //                 if (playr1) {
            //                     //console.log("audio found");
            //                     playr1.currentTime = 0;
            //                     playr1.play();
            //                 }
            //             }, d);
            //         }

            //         /////

            //         tabID.click();
            //         tabID.classList.add("tab-visited");
            //     });
            // });

			let dataTab = el.querySelectorAll("[data-tab]");
            dataTab.forEach(function (btn) {
                btn.addEventListener("click", function (e) {
                    _this.state.dataTab = this.getAttribute("data-tab");
                    _this.state.tabView = this.getAttribute("data-view");

                    let tabVar =
                        "tab_" +
                        _this.state.tabView +
                        "_" +
                        _this.state.dataTab;
                    let tabID = document.getElementById(tabVar);

                    // Проверка, что элемент с таким ID существует
                    if (!tabID) {
                        console.error(`Element with ID ${tabVar} not found`);
                        return;
                    }

                    // Определение элементов меню на основе табов
                    let menu_button_items;
                    switch (tabVar) {
                        case "tab_aboutPadcev_1":
                            menu_button_items = "Menu_AboutPad_UnmetNeed";
                            break;
                        case "tab_aboutPadcev_2":
                            menu_button_items =
                                "Menu_AboutPad_TreatmentLandscape";
                            break;
                        case "tab_aboutPadcev_3":
                            menu_button_items = "Menu_AboutPad_MOA";
                            break;
                        case "tab_aboutPadcev_4":
                            menu_button_items = "Menu_AboutPad_MOAVideo";
                            break;
                        case "tab_populationPost_1":
                            menu_button_items =
                                "Menu_TrialOverview_StudyDesign";
                            break;
                        case "tab_populationPost_2":
                            menu_button_items =
                                "Menu_TrialOverview_PatientCharacteristics";
                            break;
                        case "tab_populationCisplatin_1":
                            menu_button_items = "Menu_TrialResults_Results";
                            break;
                        case "tab_populationCisplatin_2":
                            menu_button_items = "Menu_TrialResults_Safety";
                            break;
                        case "tab_populationCisplatin_3":
                            menu_button_items = "Menu_TrialResults_QOL";
                            break;
                        case "tab_dosingAdministration_1":
                            menu_button_items = "Menu_DosingAdmin_DosingAdmin";
                            break;
                        case "tab_dosingAdministration_2":
                            menu_button_items = "Menu_DosingAdmin_DoseMods";
                            break;
                        default:
                            console.error(
                                `No menu items defined for ${tabVar}`
                            );
                            return;
                    }

                    // Обновление данных и локального хранилища
                    updateArray(menu_button_items);
                    localStorage.setItem("active_tab", tabVar);

                    // Остановка всех аудио
                    const sounds = document.querySelectorAll("audio");
                    sounds.forEach((sound) => sound.pause());

                    // Запуск аудио для текущей вкладки, если есть
                    let playr1 = document.querySelector(`#aud_${tabVar}`);
                    if (playr1) {
                        let delay = playr1.getAttribute("delay")
                            ? playr1.getAttribute("delay") * 1000
                            : 0;
                        setTimeout(() => {
                            playr1.currentTime = 0;
                            playr1.play();
                        }, delay);
                    }

                    // Клик по вкладке и установка класса "посещено"
                    tabID.click();
                    tabID.classList.add("tab-visited");
                });
            });
        });

        this.animatiions = {};
        //this.animatiions.Menu = this.createAni(this.views.popupMenu, '/assets/ani/MenuHUDFrameIn.json');
        this.animatiions.FlightInstructions = this.createAni(
            this.views.popupFlightInstructions,
            "/assets/ani/view_window.json"
        );
        this.animatiions.Summary = this.createAni(
            this.views.popupSummary,
            "/assets/ani/view_window.json"
        );

        //this.animatiions.Contact = this.createAni(this.views.popupContact, '/assets/ani/MenuHUDFrameIn.json');

        let out_el = this.views.popupoutro.querySelector(".lottie-player");
        this.outroPlyr = Lottie.loadAnimation({
            container: out_el,
            renderer: "svg",
            loop: false,
            autoplay: true,
            //   path: '/assets/ani/PilotPin.json'
        });
    }

    createAni(elm, src) {
        let plyr,
            lottie = elm.querySelector(".lottie-player");
        if (lottie) {
            plyr = Lottie.loadAnimation({
                container: lottie,
                renderer: "svg",
                loop: false,
                autoplay: false,
                path: src,
            });
        }
        return plyr;
    }

    /// add animation class for outro
    outroani() {
        this.views.popupoutro.classList.add("animated");
        if (this.outroPlyr) {
            this.outroPlyr.goToAndPlay(0);
        }
    }

    /// remove animation class for outro
    outroaniRemove() {
        this.views.popupoutro.classList.remove("animated");
    }

    /// hide all popups, turn on active popup
    update(n) {
        for (let elm in this.views) {
            if (!this.views[elm].classList.contains("hidden"))
                this.views[elm].classList.add("hidden");
        }

        if (n && typeof this.views["popup" + n] !== "undefined") {
            this.views["popup" + n].classList.remove("hidden");

            if (this.animatiions[n]) {
                this.animatiions[n].goToAndPlay(0);
            }

            let o = this.views["popup" + n].querySelectorAll("[data-button]");

            for (var i = 0; i < o.length; i++) {
                let _btn = o[i];
                /// animate button

                this.animateButtonReset(_btn);
                //setTimeout(this.animateButton(_btn), ((i + 8) * 150));
                setTimeout(this.animateButton(_btn), (i + 5) * 50);
            }
        }
    }

    /// restart the app
    revist() {
        //localStorage.setItem('state', 'revisit');
        this.state.flow = "revisit";

        //localStorage.clear();
    }

    resetHistory() {
        ////localStorage.setItem('state', 'revisit');
        //let state_revisit = localStorage.getItem('state');
        ////if (state_revisit == "revisit") {
        //	let divs = this.views.popupMenu.querySelectorAll('[data-view]');
        //localStorage.clear();
        //	for (var i = 0; i < divs.length; ++i) {
        //		divs[i].classList.remove('visited');
        //		divs[i].removeAttribute("role");
        //		divs[i].removeAttribute("aria-label");
        //	}
        //}
    }

    updateHistory(n) {
        //let o = this.views.popupMenu.querySelector('[data-view="' + n + '"]');

        setTimeout(function () {
            let o_tab = localStorage.getItem("data-num");

            let o_class = n + "_" + o_tab;
            let o_pppup = document.querySelector(
                '[data-class="' + o_class + '"]'
            );

            if (o_pppup) {
                o_pppup.classList.add("visited");
                o_pppup.setAttribute("role", "img");
                o_pppup.setAttribute(
                    "aria-label",
                    "Visited " + o_pppup.innerText
                );
            }
        }, 100);
    }

    animateButtonReset(itm) {
        itm.classList.remove("ani");
        itm.style.opacity = 0;
    }

    animateButton(itm) {
        return function () {
            let plyr = itm.ani;
            if (plyr) {
                itm.style.opacity = 1;

                plyr.goToAndPlay(0);

                plyr.addEventListener("frame", function played(e) {
                    if (e.detail.frame >= 25) {
                        plyr.pause();
                        plyr.removeEventListener("frame", played);
                    }
                });

                itm.style.opacity = 1;
                itm.querySelector(".lottie-player").style.opacity = 0.65;

                itm.classList.add("ani");
                itm.addEventListener("mouseover", function (e) {
                    this.querySelector(".lottie-player").style.opacity = 1;

                    plyr.goToAndPlay(25);
                });
                itm.addEventListener("mouseout", function (e) {
                    this.querySelector(".lottie-player").style.opacity = 0.65;

                    plyr.goToAndPlay(25);
                });
            }
        };
    }
}
